

import XHeader from 'vux/src/components/x-header/index.vue'


export default {
components: {
XHeader
},
data () {
return {
morewisNumber:this.$route.query.morewisNumber
}
},
methods: {
goBack(){

this.$router.push({
path : '/auth/login',
query : {}
})
},
gotoIndex:function(){
this.$router.push("/user/index");
}
}
}



// WEBPACK FOOTER //
// ./src/views/auth/registerSuccess.vue